define((require) => {
    "use strict";

    const CustomFontModel           = require("editor/services/fonts/customFonts/CustomFontModel");
    const RestApi                   = require("shared/services/RestApi");
    const UrlUtil                   = require("shared/util/UrlUtil");
    const AbstractFileStorage       = require("services/files/AbstractFileStorage");

    // Supported font extensions.
    const EXTENSIONS = "woff"; // no "woff2" for IE11 :(

    /**
     * The file storage service.
     *
     * @class CustomFontFileStorage
     */
    return AbstractFileStorage.extend("CustomFontFileStorage", {

        _modelInfo(file) {
            return {
                modelClass: CustomFontModel,
                url: UrlUtil.appendParamObject(RestApi.pathToCollection(RestApi.Collections.FONTS), {filename: file.name}),
                supportedTypes: EXTENSIONS
            };
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/services/files/CustomFontFileStorage.js